import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import LabelText from '../../../IN/LabelText';

const FriendName = (props) => {
	const { t } = useTranslation();
	const { friendIndex, form_component } = props;
	form_component.label = t('姓名');
	const fv = useSelector(state => state.fv);
	const pageData = useSelector(state => state.pageData);
	const controller = pageData.controller;

	const [inputValue, setInputValue] = useState('');

	const registerField = () => {
		const validator = controller === 'Shopcarts' ? window.globalFormValidator : fv;
		
		if (validator && form_component.required) {
			const fieldName = `friend[${friendIndex}][name]`;
			
			try {
				if (validator.elements && validator.elements[fieldName]) {
					validator.removeField(fieldName);
				}
				
				validator.addField(fieldName, {
					validators: {
						notEmpty: {
							message: t('此欄為必須填寫')
						}
					},
					selector: `input[name="${fieldName}"]`
				});
			} catch (error) {
				console.error('Error registering field:', fieldName, error);
			}
		}
	};

	useEffect(() => {
		registerField();
	}, [fv, controller, form_component.required, t, friendIndex]);

	useEffect(() => {
		const handleReinitialization = (event) => {
			registerField();
		};

		document.addEventListener('formValidationReinitialized', handleReinitialization);
		
		return () => {
			document.removeEventListener('formValidationReinitialized', handleReinitialization);
		};
	}, [fv, controller, form_component.required, t, friendIndex]);

	const onChange = (e) => {
		const value = e.target.value;
		setInputValue(value);
		
		if (controller === 'Shopcarts') {
			const fieldName = `friend[${friendIndex}][name]`;
			const domElement = document.querySelector(`input[name="${fieldName}"]`);
			if (domElement) {
				domElement.setAttribute('value', value);
				domElement.value = value;
			}
		}
	}

	return (
		<div className={`flex-grow-1 form-group text ${form_component.required ? 'required' : ''}`}>
			<div>
				<p className="my-0 fw-bolder fs-5">{form_component.label}</p>
				<span className="text-gray-800 fs-7 d-block xt_area"></span>
			</div>
			<input
				type="text"
				name={`friend[${friendIndex}][name]`}
				placeholder={form_component.default_text_type === 'placeholder' ? form_component.default_text : ''}
				className="form-control-sm mb-3 form-control"
				id={`friend-${friendIndex}-name`}
				value={inputValue}
				onChange={onChange}
			/>
		</div>
	);
}

export default FriendName;
